/**
 * OfflineSyncContext.js
 *
 * React Context that provides the useOfflineSync hook's state to the
 * entire component tree via AppProviders. This avoids multiple instances
 * of the hook each running their own NetInfo listener.
 */

import React, {createContext, useContext} from 'react';
import useOfflineSync from './hooks/useOfflineSync';

export const OfflineSyncContext = createContext({
  isOnline: true,
  pendingCount: 0,
  failedCount: 0,
  syncingCount: 0,
  totalUnsyncedCount: 0,
  syncStatus: {
    apiToLocal: { state: 'idle' },
    localToApi: { state: 'idle' },
  },
  pendingOrders: [],
  loadPendingOrders: async () => {},
  submitOrderOffline: async () => {},
  retryAll: async () => {},
  retryOne: async () => {},
  removeOrder: async () => {},
  refreshCounts: async () => {},
  retryApiToLocalSync: async () => {},
});

export const useOfflineSyncContext = () => useContext(OfflineSyncContext);

const OfflineSyncProvider = ({ children }) => {
  const sync = useOfflineSync();

  return (
    <OfflineSyncContext.Provider value={sync}>
      {children}
    </OfflineSyncContext.Provider>
  );
};

export default React.memo(OfflineSyncProvider);


